
import Component, { ComponentMethods } from "@/module/component/component"

import elemIcon from "@/components/elem-icon.vue"
import elemPrompt from "@/components/elem-prompt.vue"
import elemOptions from "@/components/elem-options.vue"
import compMenu from "@/components/comp-menu.vue"
import CompModel from "@/components/comp-model.vue"
import CompEmpty from "@/components/comp-empty.vue"
import CompForm from "@/components/comp-form.vue"

import Message from "@/module/interactive/message"
import Request from "@/module/request/request"
import RequestPage from "@/module/request/page"
import Utils from "@/module/utils/utils"
import Cache from "@/module/cache/cache"
import Headway from "@/module/utils/headway"
import Loading from "@/module/loading/loading"

class ToolView extends ComponentMethods implements ComponentEntity {
    components = {
        elemIcon,
        elemPrompt,
        elemOptions,
        compMenu,
        CompModel,
        CompEmpty,
        CompForm,
    }

    public title: string = "订单管理"

    private users: obj[] = null

    private requestPage: RequestPage<obj>

    private filter_title = {}

    private search: string = null

    private menu_config: obj[] = null

    private model_title: string = "数据"
    // 模块链接
    private model_url: string = null
    // 日期范围
    private date_range = null
    // 日期组件显示状态
    private date_open = false

    private filters = {}

    mode: string = "TODOS"
    // 订单消息
    order_infos: obj[] = null
    // 当前选择
    order_info_ac: obj = null
    // 待处理总数
    todo_q: number = 0

    // 订单列表
    orderList: obj[] = null

    watch = {
        order_info_ac(val: obj) {
            this.requestPage.setData({
                entity: val.id
            }, false)

            this.onChangeMode("TODOS")
        },

        date_range(v) {
            console.log(v);
        },

        filters: {
            handler(val: obj) {
                const arr = []

                Object.keys(val).forEach((key) => {
                    let item = val[key]

                    if (item instanceof Array) {
                        arr.push(...item)
                    } else {
                        arr.push(item)
                    }
                })

                this.requestPage.setData({
                    entity: this.order_info_ac.id,
                    filter: arr
                })
            },
            deep: true
        }
    }

    async created() {
        // 分页实体
        this.requestPage = new RequestPage("ADMIN://SubstanceOrder/FindAllByType", {
            load: false,
            method: "POST",
            size: 20,
            json: true,
            onChange: res => {
                this.orderList = res

                if (this.mode === "TODOS") {
                    this.todo_q = this.requestPage.getTotal()
                }
            },
        })

        await this.getAllInfo()
    }

    async getAllInfo() {
        return Request.get<obj[]>("ADMIN://SubstanceOrder/FindAllInfo", null, {
            onFail: () => {
                return false
            }
        }).then(res => {
            this.order_infos = res

            if (res?.length > 0) {
                this.order_info_ac = res[0]
            }
        })
    }

    // onResize(evt: obj) {
    //     console.log(evt);
    //     console.log(this.$refs.page.offsetWidth);
    // }

    onReachBottom() {
        this.requestPage?.load()
    }

    onSubmitSearch() {
        if (!this.search) {
            delete this.filters['search']
            return
        }

        this.filters['search'] = {
            key: "orderNumber",
            value: this.search,
            operator: "equal",
            fuzzy: true
        }
    }

    onClearSearch() {
        this.search = ""
        delete this.filters['search']
    }

    /**
     * 价格单位 分 转 元，保留两位小数
     * @param amount 金额，单位：分
     */
    centsToYuan(amount: number): string {
        if (!amount) {
            return "0.00"
        }

        return (amount / 100).toFixed(2)
    }

    /**
     * 获取地址
     */
    getAddress(e: obj): string {
        var res = []

        Utils.each(["country", "province", "city"], v => {
            e[v] && res.push(e[v])
        })

        return res.length > 0 ? res.join("-") : "-"
    }

    /**
     * 随机生成十六进制颜色
     */
    getRandomHexColor() {
        return "#" + ("00000" + ((Math.random() * 0x1000000) << 0).toString(16)).substr(-6)
    }

    getMenu(item: obj): obj[] {
        let arr: obj[] = [
            {
                title: "数据",
                sub: [
                    {
                        id: "CopyOrderNumber",
                        icon: "copy",
                        name: "复制订单号",
                    },
                    ...(item.address
                        ? [
                              {
                                  id: "CopyAddress",
                                  icon: "copy",
                                  name: "复制收货信息",
                              },
                          ]
                        : []),
                ],
            },
            {
                title: "操作",
                prompt: "删除数据后将无法恢复，请谨慎操作！",
                sub: [
                    {
                        id: "Delete",
                        icon: "delete",
                        name: "删除订单",
                    },
                ],
            },
        ]

        if (this.menu_config && this.menu_config.length > 0) {
            arr.push({
                title: "管理",
                sub: this.menu_config,
            })
        }

        return arr
    }

    onSelectMenu(item: obj, evt: ElemEvent<string>) {
        switch (evt.value) {
            case "CopyOrderNumber":
                Utils.copyText(item.orderNumber)
                Message.success("复制成功")
                break
            case "CopyAddress":
                Utils.copyText([item.address.name, item.address.phone, `${[item.address.province, item.address.city, item.address.district, item.address.address].join('')}`].join(" "))
                Message.success("复制成功")
                break
            case "Delete":
                this.onDeleteOrder(item)
                break
            case "Href":
                evt.data.href && this.jump(this.getUrl(item, evt.data.href))
                break
            case "Model":
                this.onOpenModel(evt.data, item)
        }
    }

    /**
     * 打开窗口
     */
    onOpenModel(data: obj, user: obj) {
        Loading.show()

        this.model_title = data.name
        this.model_url = data.url
        this.current_user = user

        this.$nextTick(() => {
            new Headway(this, "isLoadedIframe").on().then(() => {
                this.$refs.comp_model.onDisplay()

                this.$refs.iframe.contentWindow.postMessage(
                    {
                        type: "OpenMembership",
                        user_id: this.current_user.uuid,
                        authorization_token: Cache.get("admin_token", ""),
                        authorization_user: Cache.get("admin_id", ""),
                    },
                    "*"
                )

                Loading.hide()
            })
        })
    }

    /**
     * 解析 url
     */
    getUrl(data: obj, url: string): string {
        return new Function(`return \`${url.replace(/&{(\w*)}/g, "${this.data.$1}")}\``).call({
            data: data,
        })
    }

    onDeleteOrder(user: obj) {
        Message.info("确认删除当前订单？", true)
            .onConfirm(() => {
                Request.delete("ADMIN:///Delete", { user: user.uuid }).then(() => {
                    Utils.each(
                        this.users,
                        () => "delete",
                        c => c.uuid === user.uuid
                    )
                    Message.success("删除成功")
                })
            })
            .build()
    }

    onChangeMode(mode: string) {
        this.mode = mode

        var filters: obj = [{
            key: "paymentStatus",
            value: 1,
            operator: "equal",
        }]

        switch (mode) {
            case "TODOS":
                filters.push({
                    key: "transportStatus",
                    value: ["WAITING_ACCEPT", "WAITING_SHIPMENTS"],
                    operator: "equal",
                    relation: "or",
                })
                break
        }
        
        this.filters['mode'] = filters
        // this.requestPage.setData({
        //     entity: this.order_info_ac.id,
        //     type: mode
        // })
    }

    onLoadIframe() {
        this.isLoadedIframe = true
    }

    /**
     * 接单
     */
    onAccepted(item: obj) {
        Request.post("ADMIN://GoodsOrder/Receiving", {
            uuid: item.uuid,
        }).then(() => {
            Message.success("接单成功")
            item.transportStatus = "WAITING_SHIPMENTS"
        })
    }

    /**
     * 发货
     */
    onShipments(item: obj) {
        this.$refs.comp_form.display({
            title: "发货",
            method: "POST",
            submitApi: "ADMIN://GoodsOrder/Delivery?uuid=" + item.uuid,
            structure: [
                {
                    type: "ORDINARY",
                    data: [
                        {
                            field: "expressNumber",
                            name: "expressNumber",
                            title: "快递单号",
                            length: 255,
                            required: true,
                            type: "Input",
                        },
                        {
                            field: "expressCompany",
                            name: "expressCompany",
                            title: "快递公司",
                            length: 255,
                            required: true,
                            type: "Select",
                            modify: true,
                            selectConfig: {
                                field: null,
                                controller: true,
                                data: null,
                                selectField: {},
                                multiple: false,
                                type: "com.jemmy.framework.component.order.substance.delivery.DeliveryCompany"
                            }
                        },
                    ],
                    title: "通用数据",
                    exist: true,
                },
            ],
            data: item,
        })
    }

    onChangeDate(evt: string[]) {
        if (evt?.[0] && evt?.[1]) {
            if (evt[0] === evt[1])
                this.filters['date'] = {
                    key: "createdDate",
                    value: evt[0],
                    type: "date",
                    operator: "equal",
                }
            else
                this.filters['date'] = [
                    {
                        key: "createdDate",
                        value: evt[0],
                        type: "date",
                        operator: "greater_equal",
                    },
                    {
                        key: "createdDate",
                        value: evt[1],
                        type: "date",
                        operator: "less_equal",
                    }
                ]

            this.date_range = evt
        } else {
            this.date_range = null
            delete this.filters['date']
        }

        // 设置为关闭状态
        this.date_open = false
    }

    /**
     * 表单提交成功事件
     */
    onSubmitForm(evt: obj) {
        Message.success("发货成功")
        evt.value.data.transportStatus = "WAITING_RECEIPT"
    }

    getOrderStatus(item: obj) {
        let p = { 0: "未支付", 2: "已取消", 3: "支付失败" }[item.paymentStatus]
        if (p) return p
        return (
            { WAITING_ACCEPT: "待接单", WAITING_DELIVERED: "待配送", WAITING_GET: "待取货", WAITING_SHIPMENTS: "待发货", WAITING_RECEIPT: "待收货", WAITING_COMMENT: "待评价", SUCCESS: "已完成" }[item.transportStatus] || "未知"
        )
    }

    getOrderStatusColor(item: obj) {
        if (item.paymentStatus !== 1) {
            return "#333"
        }

        return {
            WAITING_ACCEPT: "#007843",
            WAITING_SHIPMENTS: "#00acdb"
        }[item.transportStatus] || "#333"
    }
}

export default Component.build(new ToolView())
